'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasBotMessages = undefined;

var _some = require('transmute/some');

var _some2 = _interopRequireDefault(_some);

var _isFromBot = require('../../pubnub-message/operators/isFromBot');

var _hasMessages = require('./hasMessages');

var _getMessages = require('./getMessages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasBotMessages = exports.hasBotMessages = function hasBotMessages(threadHistory) {
  return (0, _hasMessages.hasMessages)(threadHistory) && (0, _some2.default)(_isFromBot.isFromBot, (0, _getMessages.getMessages)(threadHistory));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/hasBotMessages.js
// module id = 175
// module chunks = 2 3